<template>
  <b-container fluid>    
    <loading :active.sync="isLoading" color="#00AB63"></loading>
    
    <b-row>
      <b-col sm="8">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Agregar producto</h4>
          <div class="media text-muted pt-3">
            <b-form @submit="saveProduct($event)" style="width: 100%;">
              <b-row>
                <b-col sm="6">
                  <b-form-group label="Nombre:">
                    <b-form-input
                      placeholder="Nombre del producto"
                      v-model="newProduct.productName"
                      required
                    ></b-form-input> 
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group sm="6" label="Precio:">
                    <b-form-input type="number" v-model="newProduct.price" step="any" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group sm="6" label="Precio con descuento:">
                    <b-form-input type="number" v-model="newProduct.priceWDisc" step="any" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="6"
                  v-if="((selectedType.name !='Montajes' &&  selectedType.name !='Materiales de instalación eléctrica' && selectedType.name !='Adicionales de estructuras' && selectedType.name !='Trámites' && selectedType.name !='Coberturas') && selectedType.name!='')"
                >
                  <b-form-group label="Marca:">
                    <b-form-select v-model="newProduct.brand" :options="brands" required></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="6"
                  v-if="selectedType.name=='Paneles solares' || selectedType.name=='Estructuras' || selectedType.name=='Inversores'"
                >
                  <b-form-group label="Capacidad:">
                    <b-form-input type="number" v-model="newProduct.capacity" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6" v-if="selectedType.name !='Trámites' && selectedType.name!=''">
                  <b-form-group label="Imagen:">
                    <b-form-file
                      v-model="img"
                      accept="image/jpeg, image/png"
                      placeholder="Ningún archivo elegido"
                      browse-text="Buscar"
                      @change="selectImageForNewProduct($event)"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="6"
                  v-if="selectedType.name == 'Paneles solares' && selectedType.name !='Trámites' && selectedType.name!=''"
                >
                  <b-form-group label="Tipo:">
                    <b-form-radio-group
                      :options="panel_types"
                      v-model="newProduct.optionsSelected"
                      required
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="6"
                  v-if="selectedType.name == 'Inversores' && selectedType.name !='Trámites' && selectedType.name!=''"
                >
                  <b-form-group label="Tipo:">
                    <b-form-radio-group
                      :options="inversor_types"
                      v-model="newProduct.optionsSelected"
                      required
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="6"
                  v-if="(selectedType.name == 'Paneles solares' || selectedType.name == 'Inversores')&& selectedType.name !='Trámites' && selectedType.name!=''"
                >
                  <b-form-group label="Compatible con:">
                    <b-form-checkbox-group
                      :options="compatibilidad"
                      v-model="newProduct.compatibilidadSelected" 
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="img!=null && (img.type == 'image/png' || img.type == 'image/jpeg')">
                  <h6>Vista previa:</h6>
                  <img id="img" src alt class="img-thumbnail" style="width:200px;" />
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6"></b-col>
                <b-col sm="6">
                  <b-button
                    type="submit"
                    variant="primary"
                    class="float-right boton_createch"
                    :disabled="(selectedType.name == '' || show)"
                  >
                    Agregar
                    <b-spinner small v-if="show"></b-spinner>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </b-col>
      <b-col sm="4">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Tipos</h4>
          <div class="media text-muted pt-3">
            <b-form @submit="addNewType($event)" style="width: 100%;">
              <b-row>
                <b-col sm="12">
                  <b-form-group
                    label="Seleccione tipo de producto"
                    style="height: 200px; overflow-y: scroll;"
                  >
                    <div v-for="tipo in productTypes" v-bind:key="tipo._id">
                      <b-form-radio v-model="selectedType" :value="tipo">{{tipo.name}}
                        <a  @click="eliminarTipo(tipo)" style="margin-left:10px;" v-if="!types_default.includes(tipo.name)"><i class="fas fa-times"></i></a>
                      </b-form-radio>
                    </div>
                  </b-form-group>
                  <b-form-group class="mt-2" label="Tipo personalizado">
                    <b-input v-model="newType.name" placeholder="Escriba tipo nuevo" required></b-input>
                  </b-form-group>
                  <b-button
                    type="submit"
                    variant="primary"
                    block
                    class="boton_createch"
                    :disabled="newType.name == ''"
                  >Agregar</b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Tabla inferior -->

    <b-row>
      <b-col>
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">{{selectedType.name}}</h4>

          <div class="media text-muted pt-3">
            <b-container fluid>
              <!-- User Interface controls -->
              <b-row class="mb-4">
                <b-col sm="10">
                  <b-form-group label="Buscar" label-for="filterInput" class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input v-model="productsTable.filter" type="search" placeholder="Palabra a buscar" id="filterInput"></b-form-input>
                      <b-input-group-append>
                        <b-button
                          :disabled="!productsTable.filter"
                          @click="productsTable.filter = ''"
                        >Borrar</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group label="Por Pagina" label-for="perPageSelect" class="mb-0">
                    <b-form-select
                      v-model="productsTable.perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="productsTable.pageOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <b-table
                show-empty
                small
                stacked="md"
                :items="productsTableByType"
                :fields="productsTable.fields"
                :current-page="productsTable.currentPage"
                :per-page="productsTable.perPage"
                :filter="productsTable.filter"
                :filterIncludedFields="productsTable.filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(name)="row">{{ row.value.first }} {{ row.value.last }}</template>
                <template v-slot:cell(actions)="row">
                  <!-- <b-button size="sm" @click="view(row.item._id)" class="mr-1" variant="light"><i class="far fa-eye"></i></b-button> -->
                  <b-button
                    @click="createEditModal(row.item, $event.target)"
                    class="mr-1 btn_editar" 
                  >
                    <i class="far fa-edit"></i>
                  </b-button>

                  <b-button
                    size="sm"
                    @click="createDeleteModal(row.item,$event.target)"
                    class="mr-1 btn_borrar" 
                  >
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                </template>
                <template v-slot:row-details="row">
                  <b-card>
                    <ul>
                      <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                    </ul>
                  </b-card>
                </template>
              </b-table>
              <b-container>
                <b-row class="justify-content-end">
                  <b-col sm="5">
                    <b-pagination
                      v-model="productsTable.currentPage"
                      :total-rows="productsTable.totalRows"
                      :per-page="productsTable.perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-container>
            </b-container>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- info modal -->

    <b-modal
      :id="infoModal.id"
      :title="infoModal.title"
      centered
      @ok="deleteProduct()"
      ok-title="Eliminar"
      cancel-title="Cancelar"
    >
      <p
        style="text-align:center; font-size:25px; font-weight:bold;"
      >¿Está seguro que desea eliminar?</p>
    </b-modal>

    <b-modal :id="editModal.id" hide-footer size="lg" :title="editModal.title" centered>
      <b-container>
        <b-row>
          <b-form @submit="updateProduct($event)" style="width: 100%;">
            <b-row>
              <b-col sm="12">
                <b-form-group label="Nombre:">
                  <b-form-input
                    placeholder="Nombre del producto"
                    v-model="editModal.new.productName"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4" v-if="editModal.new.brand === undefined || editModal.new.brand===null">
                <b-form-group label="Marca:">
                  <b-form-select v-model="editModal.new.brand" :options="brands" required></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Precio:">
                  <b-form-input type="number" v-model="editModal.new.price" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Precio con descuento:">
                  <b-form-input type="number" v-model="editModal.new.priceWDisc" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                sm="4"
                v-if="editModal.new.typeName=='Paneles solares' || editModal.new.typeName=='Estructuras' || editModal.new.typeName=='Inversores'"
              >
                <b-form-group label="Capacidad:">
                  <b-form-input type="number" v-model="editModal.new.capacity" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4" v-if="editModal.new.typeName=='Inversores'">
                <b-form-group label="Tipo:">
                  <b-form-radio-group
                    :options="inversor_types"
                    v-model="editModal.new.type_product"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col sm="4" v-if="editModal.new.typeName=='Paneles solares'">
                <b-form-group label="Tipo:">
                  <b-form-radio-group
                    :options="panel_types"
                    v-model="editModal.new.type_product"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="4"
                v-if="editModal.new.typeName=='Paneles solares'||editModal.new.typeName=='Inversores'"
              >
                <b-form-group label="Compatible con:">
                  <b-form-checkbox-group
                    :options="compatibilidad"
                    v-model="editModal.new.compatibilidad" 
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="editModal.new.typeName != 'Trámites'">
              <b-col sm="12">
                <b-form-group label="Imagen:">
                  <b-form-file
                    id="img2"
                    v-model="img_edit"
                    accept="image/jpeg, image/png"
                    @change="selectImageForUpdate($event)"
                    class="mt-3"
                    placeholder="Ningún archivo elegido"
                      browse-text="Buscar"
                  />
                </b-form-group> 
              </b-col>
              <b-col sm="6" v-if="editModal.new.img">
                <h6>Imagen actual:</h6>
                <img
                  id="img"
                  :src="editModal.new.img"
                  alt
                  class="img-thumbnail"
                  style="width:200px;"
                />
              </b-col>
              <b-col
                sm="6"
                v-if="img_edit!=null && (img_edit.type == 'image/png' || img_edit.type == 'image/jpeg')"
              >
                <b-form-group label="Nueva imagen">
                  <img id="img_edit" src alt class="img-thumbnail" style="width:200px;" />
                </b-form-group>
              </b-col>
            </b-row>
            <hr />
            <div class="float-right">
              <b-button
                variant="secondary"
                size="sm"
                class="mr-1"
                @click="ocultaModal(editModal.id)"
              >Cancelar</b-button>
              <b-button type="submit" variant="primary" size="sm" :disabled="edit_btn_show">
                Editar
                <b-spinner small v-if="edit_btn_show"></b-spinner>
              </b-button>
            </div>
          </b-form>
        </b-row>
      </b-container> 
       
    </b-modal> 
  </b-container>
</template>

<script>
import axios from "axios";
import * as firebase from "firebase/app";
import "firebase/storage";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      isLoading: false,
      checkbox: true,
      products: [],
      productsTableByType: [],
      img: null,
      img_edit: null,
      show: false,
      edit_btn_show: false,
      newProduct: {
        productName: "",
        price: 0,
        priceWDisc: 0,
        urlImage: "",
        type: "",
        brand: null,
        capacity: 0,
        compatibilidadSelected: [],
        optionsSelected: null
      },
      panel_types: [
        { text: "Poly", value: "Poly" },
        { text: "Mono", value: "Mono" },
        { text: "KuMax", value: "KuMax" }
      ],
      inversor_types: [
        { text: "Micro", value: "Micro" },
        { text: "Central", value: "Central" }
      ],
      compatibilidad: [
        { text: "Comercial", value: "Comercial" },
        { text: "Domestico", value: "Domestico" },
        { text: "Industrial", value: "Industrial" }
      ],
      newType: {
        name: ""
      },
      productTypes: [],
      types_default: ['Paneles solares', 'Inversores', 'Adicionales de estructuras', 'Monitoreos', 'Coberturas', 'Materiales de instalación eléctrica', 'Montajes', 'Trámites', 'Estructuras'],
      brands: [],
      selectedType: {
        _id: "",
        name: "Productos"
      },
      productsTable: {
        fields: [
          { key: "productName", sortable:true, label: "Nombre", thStyle: { width: "50%" } },
          { key: "brand.name", sortable:true, label: "Marca", thStyle: { width: "10%" } },
          { key: "price", sortable:true, label: "Precio", thStyle: { width: "10%" } },
          {
            key: "type.name", sortable:true,
            label: "Tipo de producto",
            filterByFormatted: true,
            thStyle: { width: "20%" }
          },
          { key: "actions", label: "", thStyle: { width: "10%" } }
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 5,
        pageOptions: [5, 10, 15],
        filter: null,
        filterOn: []
      },
      editModal: {
        id: "edit-modal",
        title: "",
        new: {
          productName: "",
          price: "0",
          priceWDisc: 0,
          img: "",
          type: "",
          brand: null,
          capacity: "0",
          compatibilidad: [],
          type_product: null
        },
        img: "",
        disableBtn: false
      },
      infoModal: {
        eliminar: "",
        title: "",
        id: "info-modal"
      }
    };
  },
  components: {
    Loading
  },
  created() {
    this.getProducts();
    this.getProductTypes();
    this.getBrands();
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  watch: {
    selectedType: function(newValue, old) {
      //this.getProducts();
      this.selectProductType();
      this.isLoading = false;
      this.img = null;
    },
    "newProduct.compatibilidadSelected": function(newValue, old) {
      if (newValue.length > 0) {
        this.checkbox = false;
      } else {
        this.checkbox = true;
      }
    }
  },
  methods: {
    getProducts() {
      let me = this;
      this.isLoading = true;
      axios
        .get("products")
        .then(res => {
          me.productsTable.totalRows = res.data.length;
          this.products = res.data;
          this.productsTableByType = res.data;
          this.isLoading = false;
        })
        .catch(error => {});
    },
    selectProductType() {  
      this.productsTableByType = [];
      if (this.selectedType.name != "") {
        this.productsTableByType = this.products.filter( 
          p => p.type.name == this.selectedType.name
        );
        this.productsTable.totalRows = this.productsTableByType.length;
      } else {
        for (const p of this.products) {
          this.productsTableByType.push(p);
        }
        this.productsTable.totalRows = this.productsTableByType.length;
      }
    },
    saveProduct(event) {  
      event.preventDefault();
      if (this.selectedType._id != "") {
        if (this.img != null) {
          if (
            this.img.type === "image/png" ||
            this.img.type === "image/jpg" ||
            this.img.type === "image/jpeg"
          ) {
            this.isLoading = true;
            this.show = true;
            this.newProduct.type = this.selectedType._id;
            const imgName = `${Date.now()}_${this.img.name}`;
            const uploadedimg = firebase
              .storage()
              .ref()
              .child(`products/${imgName}`)
              .put(this.img);
            uploadedimg.on(
              `state_changed`,
              snapshot => {},
              error => {},
              () => {
                uploadedimg.snapshot.ref.getDownloadURL().then(url => {
                  this.newProduct.urlImage = url;
                  axios
                    .post("product", {
                      product: {
                        name: this.newProduct.productName,
                        price: this.newProduct.price,
                        priceWDisc: this.newProduct.priceWDisc,
                        brand: this.newProduct.brand,
                        type: this.newProduct.type,
                        capacity: this.newProduct.capacity,
                        urlImage: this.newProduct.urlImage,
                        type_product: this.newProduct.optionsSelected,
                        compatibility: this.newProduct.compatibilidadSelected,
                        imageName: imgName
                      },
                      type: this.selectedType.name
                    })
                    .then(res => {
                      if (res.status === 201) {
                        this.resetProduct();
                        this.getProducts();
                      } else if (res.status === 202) {
                        this.makeToast(
                          "Ya existe un producto con ese nombre",
                          "Productos"
                        );
                      } else {
                        this.makeToast("Ocurrió un error inesperado");
                      }
                      this.show = false;
                      this.isLoading = false;
                    })
                    .catch(error => {});
                });
              }
            );
          } else {
            this.makeToast(
              "Debe seleccionar una imagen jpg o png.",
              "Selección de imagen"
            );
          }
        } else {
          this.isLoading = true;
          this.newProduct.type = this.selectedType._id;
          axios
            .post("product", {
              product: {
                name: this.newProduct.productName,
                price: this.newProduct.price,
                priceWDisc: this.newProduct.priceWDisc,
                brand: this.newProduct.brand,
                type: this.newProduct.type,
                capacity: this.newProduct.capacity,
                type_product: this.newProduct.optionsSelected,
                compatibility: this.newProduct.compatibilidadSelected
              },
              type: this.selectedType.name
            })
            .then(res => {
              if (res.status === 201) {
                this.resetProduct();
                this.getProducts();
              } else if (res.status === 202) {
                this.makeToast(
                  "Ya existe un producto con ese nombre",
                  "Productos"
                );
              } else {
                this.makeToast("Ocurrió un error inesperado");
              }
              this.getProducts();
              this.show = false;
              this.isLoading = false;
            });
        }
      } else {
        this.makeToast(
          "Debe seleccionar un tipo de producto",
          "Guardar producto"
        );
      }
    },
    updateProduct(event) {
       
      let product = null;
      event.preventDefault();
      this.isLoading = true;
      if (this.img_edit != null) {
        if (
          this.img_edit.type === "image/png" ||
          this.img_edit.type === "image/jpg" ||
          this.img_edit.type === "image/jpeg"
        ) {
          this.edit_btn_show = true;
          const imgName = Date.now() + "_" + this.img_edit.name;



          const uploadedimg = firebase
            .storage()
            .ref()
            .child("products/" + imgName)
            .put(this.img_edit);
          uploadedimg.on(
            `state_changed`,
            snapshot => {},
            error => {},
            () => {
              uploadedimg.snapshot.ref.getDownloadURL().then(url => {
                this.editModal.new.urlImage = url; 
                axios
                  .put(`product/${this.editModal.new.id}`, {
                    type: this.editModal.new.type,
                    product: {
                      name: this.editModal.new.productName,
                      price: this.editModal.new.price,
                      priceWDisc: this.editModal.new.priceWDisc,
                      type: this.editModal.new.type,
                      brand: this.editModal.new.brand,
                      capacity: this.editModal.new.capacity,
                      compatibility: this.editModal.new.compatibilidad,
                      type_product: this.editModal.new.type_product,
                      urlImage: this.editModal.new.urlImage,
                      imageName: imgName
                    }
                  })
                  .then(res => {
                    if (res.status === 200) {
                      
                      this.edit_btn_show = false;
                      this.ocultaModal(this.editModal.id);
                      this.getProducts();
                      this.resetProductUpdate();
                    } else if (res.status === 202) {
                      this.makeToast(
                        "Ya existe otro producto con ese nombre.",
                        "Productos"
                      );
                    } else {
                      this.makeToast("Ocurrió un error inesperado", "Error");
                    }

                    this.isLoading = false;
                  })
                  .catch(error => {
                    this.makeToast("Ocurrió un error inesperado", "Alerta");
                    this.edit_btn_show = false;
                    this.isLoading = false;
                  });
              });
            }
          );
        } else {
          this.makeToast(
            "Debe seleccionar un tipo de producto",
            "Guardar producto"
          );
          this.isLoading = false;
        }
      } else {
        this.isLoading = true;
        
        axios
          .put(`product/${this.editModal.new.id}`, {
            type: this.editModal.new.typeName,
            product: {
              name: this.editModal.new.productName,
              price: this.editModal.new.price,
              priceWDisc: this.editModal.new.priceWDisc,
              type: this.editModal.new.type,
              brand: this.editModal.new.brand,
              capacity: this.editModal.new.capacity,
              compatibility: this.editModal.new.compatibilidad,
              type_product: this.editModal.new.type_product
            }
          })
          .then(res => {
            if (res.status === 200) {
              this.edit_btn_show = false;
              this.ocultaModal(this.editModal.id);
              this.getProducts();
              this.resetProductUpdate();
            } else if (res.status === 202) {
              this.makeToast(
                "Ya existe otro producto con ese nombre.",
                "Productos"
              );
            } else {
              this.makeToast("Ocurrió un error inesperado", "Error");
            }

            this.isLoading = false;
          })
          .catch(error => {
            this.makeToast("Ocurrió un error inesperado", "Alerta");
            this.edit_btn_show = false;
            this.isLoading = false;
          });
      } 
    },
    deleteProduct() {
      this.isLoading = true; 
      axios
        .delete(`product/${this.infoModal.eliminar}`)
        .then(res => { 
          if (res.status == 200) {
            if (res.data) { 
              this.getProducts();
              this.isLoading = false;
            } else {
              const imgName = res.data;
              const firebaseRef = firebase
                .storage()
                .ref()
                .child(`products/${imgName}`)
                .delete()
                .then(res => {
                  this.getProducts();
                  this.isLoading = false;
                });
            }
          } else {
            this.isLoading = false;
            this.makeToast("No se encontró el producto", "Eliminar producto");
          } 
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast(
            "Ocurrió un error al borrar el producto",
            "Borrar producto"
          );
        });
    },
    getBrands() {
      this.isLoading = true; 
      axios
        .get("brands")
        .then(res => { 
          this.brands.push({ text: "Seleccione marca", value: null });
          for (const brand of res.data) { 
            this.brands.push({ text: brand.name, value: brand._id });
          }
          this.isLoading = false;
        })
        .catch(error => {});
    },
    getProductTypes() {
      this.isLoading = true;
      axios
        .get("types")
        .then(res => {
          if (res.data) { 
            this.productTypes = res.data;
          }
          this.isLoading = false;
        })
        .catch(error => {});
    },
    addNewType(event) {
      event.preventDefault();
      this.isLoading = true;
      axios
        .post("types", this.newType)
        .then(res => {
          if (res.status === 202) {
            this.makeToast(
              "Ya existe un tipo con ese nombre.",
              "Tipo de producto."
            );
            this.isLoading = false;
          } else {
            this.getProductTypes();
            this.newType.name = "";
            this.isLoading = false;
          }
        })
        .catch(error => {});
    },
    onFiltered(filteredItems) {
      this.productsTable.totalRows = filteredItems.length;
      this.productsTable.currentPage = 1;
    },
    view(id_product) {
      this.$router.replace({ name: "id", params: { id: id_product } });
    },
    createEditModal(item, button) { 
      this.resetProductUpdate();
      this.editModal.new.productName = item.productName;
      this.editModal.new.id = item._id;
      this.editModal.new.price = item.price;
      this.editModal.new.priceWDisc = item.priceWDisc;
      this.editModal.new.type = item.type._id;
      this.editModal.new.typeName = item.type.name;
      this.editModal.new.img = item.urlImage;
      if (item.brand) {
        this.editModal.new.brand = item.brand._id;
      }
      if (item.compatibility) {
        this.editModal.new.compatibilidad = item.compatibility;
      }
      if (item.type_product) {
        this.editModal.new.type_product = item.type_product;
      }
      if (item.capacity) {
        this.editModal.new.capacity = item.capacity;
      }
      this.editModal.title = `Editar producto: ${item.productName}`;
      this.$root.$emit("bv::show::modal", this.editModal.id, button);
    },
    createDeleteModal(item, button) {
      this.infoModal.title = `Eliminar tarifa: ${item.productName}`;
      this.infoModal.eliminar = item._id;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    ocultaModal(id) {
      this.$bvModal.hide(id);
      this.img_edit = null;
    },
    selectImageForNewProduct(event) {
      let img = event.target.files[0];
      if (img) {
        if (
          img.type === "image/png" ||
          img.type === "image/jpg" ||
          img.type === "image/jpeg"
        ) {
          this.img = img;
          let reader = new FileReader();
          reader.onload = function(e) {
            document.getElementById("img").src = e.target.result;
          };
          reader.readAsDataURL(img);
        } else {
          this.makeToast(
            "Debe seleccionar una imagen jpg o png",
            "Selección de imagen"
          );
        }
      }
    },
    selectImageForUpdate(event) {
      let img = event.target.files[0];
      if (img) {
        if (
          img.type === "image/png" ||
          img.type === "image/jpg" ||
          img.type === "image/jpeg"
        ) {
          this.img_edit = img;
          let reader = new FileReader();
          reader.onload = function(e) {
            document.getElementById("img_edit").src = e.target.result;
          };
          reader.readAsDataURL(img);
        } else {
          this.makeToast(
            "Debe seleccionar una imagen jpg o png.",
            "Selección de imagen"
          );
        }
      }
    },
    resetProduct() {
      this.newProduct = {
        productName: "",
        price: 0,
        priceWDisc: 0,
        urlImage: "",
        type: "",
        brand: null,
        capacity: 0,
        compatibilidadSelected: [],
        optionsSelected: null
      };
      this.selectedType = {
        _id: "",
        name: ""
      };
      this.img = null;
    },
    resetProductUpdate() {
      this.editModal = {
        id: "edit-modal",
        title: "",
        new: {
          productName: "",
          price: "0",
          priceWDisc: 0,
          img: "",
          type: "",
          brand: null,
          capacity: "0",
          compatibilidad: [],
          type_product: null
        },
        img: "",
        disableBtn: false
      };
      this.img_edit = null;
    },
    eliminarTipo(tipo){ 
      axios
        .delete("types/" + tipo._id)
        .then(res => { 
          this.getProductTypes();
        })
        .catch(error => {
          this.makeToast("Ocurrió un error inesperado.", "Error");
        });
    }
  }
};
</script>
    
<style>
</style>